<template>
  <div class="tests">
    <div class="wrapper">
      <h1>Тестовые задания</h1>
      <div class="tests__links" v-if="linksArray && linksArray.length">
        <router-link v-for="(link, indexLink) in linksArray" :key="indexLink" :to="link.href" class="tests__link" :class="{'tests__link_selected': isActive(link)}">{{link.name}}</router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Tests",
  data () {
    return {
      linksArray: [
        {name: 'от ДОМ.РФ', href: '/tests/domRF/'},
        {name: 'от Mediapronet', href: '/tests/mediapronet/'},
        {name: 'от Klerk', href: '/tests/klerk/'},
        {name: 'от Транскапиталбанк', href: '/tests/tkb/'},
        {name: 'от Дрим Тим', href: '/tests/dreamte/'},
        {name: 'от Smail Tech', href: '/tests/smile-tech/'},
        {name: 'от Экодар', href: '/tests/ekodar/'},
        {name: 'от ИП Рудова Д.А.', href: '/tests/rda/'},
        {name: 'от PROFIT agency', href: '/tests/profit/'},
      ]
    }
  },
  methods: {
    isActive (itemMenu) {
      return this.$route.path.indexOf(itemMenu.href) === 0
    }
  }
}
</script>

<style lang="scss" scoped>
  .tests {
    position: relative;

    &__links {
      position: relative;
      margin: -5px -3px 0;
    }

    &__link {
      display: inline-block;
      height: 30px;
      margin: 5px 3px 0;
      padding: 0 10px;
      border: 1px solid $color-link;
      border-radius: 10px;
      background: $color-link;
      @include font(14px, 30px, #ffffff);
      text-decoration: none;

      &:hover:not(&_selected) {
        background: $color-link-hover;
        border-color: $color-link-hover;
      }

      &_selected {
        background: #ffffff;
        cursor: default;
        color: $color-link;
      }
    }
  }
</style>